var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboardCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 112,
    viewBox: "0 0 192 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.9995 41L111 84H81L95.9995 41Z",
    fill: "#F77622"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4564 41L81 84H93.766C97.43 84 100.304 81.0463 99.9742 77.619L96.4564 41Z",
    fill: "#FC9A2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.155 2.74866L107.036 19.2459C107.682 20.7952 109.155 21.8526 110.845 21.9817L128.845 23.3523C132.844 23.6567 134.467 28.593 131.412 31.1625L117.665 42.7287C116.374 43.8144 115.811 45.5265 116.21 47.1546L120.455 64.4995C121.397 68.3528 117.149 71.4036 113.733 69.327L98.3552 59.9781C96.9113 59.1004 95.0905 59.1004 93.6466 59.9781L78.2692 69.327C74.8532 71.4036 70.6046 68.3528 71.5473 64.4995L75.7913 47.1546C76.1897 45.5256 75.6275 43.8144 74.3367 42.7287L60.5876 31.1634C57.5332 28.5939 59.1562 23.6576 63.155 23.3532L81.1552 21.9826C82.8453 21.8543 84.3188 20.7961 84.9642 19.2468L91.8464 2.74866C93.3753 -0.916219 98.6265 -0.916219 100.155 2.74866H100.155Z",
    fill: "#FFA800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.455 64.5015C121.398 68.3531 117.149 71.4039 113.733 69.3282L98.3546 59.9793C96.9107 59.1016 95.089 59.1016 93.645 59.9793L85.5553 64.8988C83.2001 66.3313 80.2487 64.3025 80.7876 61.6215L81.535 57.8982L92.2915 50.1729L105.352 49.5633L107.305 39.3916L119.405 30.7036L123.289 30.8753C126.163 31.0027 127.392 34.5446 125.201 36.3885L117.664 42.7308C116.373 43.8174 115.812 45.5277 116.21 47.1566L120.454 64.5024L120.455 64.5015Z",
    fill: "#F77622"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0012 25.4489C98.4871 30.141 103.005 33.3856 108.288 34.2731C104.541 38.06 102.815 43.3114 103.595 48.5521C101.239 47.4027 98.6428 46.8011 96.0003 46.8011C93.3577 46.8011 90.7617 47.4027 88.4056 48.5521C89.1853 43.3114 87.4593 38.06 83.7121 34.2731C88.9955 33.3865 93.5135 30.141 95.9994 25.4489H96.0012ZM96.0012 13.895L92.4903 22.3131C90.6632 26.6929 86.5606 29.6393 81.7821 30.003L72.5967 30.702L79.6113 36.6036C83.261 39.6739 84.8284 44.4422 83.7014 49.0467L81.5359 57.8966L89.3822 53.1266C91.374 51.9161 93.6621 51.2755 96.0003 51.2755C98.3385 51.2755 100.627 51.9152 102.618 53.1266L110.465 57.8966L108.299 49.0467C107.173 44.4422 108.74 39.6748 112.389 36.6036L119.404 30.702L110.219 30.003C105.441 29.6393 101.337 26.692 99.5112 22.3131L96.0003 13.895H96.0012Z",
    fill: "#993328"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6116 36.6046L72.597 30.703L81.7824 30.004C86.5609 29.6403 90.6644 26.693 92.4906 22.3141L96.0015 13.896L99.5124 22.3141C99.5222 22.3371 99.5312 22.3592 99.541 22.3822C100.892 25.5693 105.284 26.0241 107.337 23.2272L108.76 21.2886C108.002 20.8064 107.394 20.1021 107.036 19.2473L100.155 2.74919C99.3915 0.917638 97.696 0.000976562 96.0015 0.000976562C94.3069 0.000976562 92.6114 0.916754 91.8469 2.74919L84.9657 19.2465C84.3194 20.7958 82.8468 21.8531 81.1567 21.9823L63.1564 23.3528C59.1577 23.6572 57.5347 28.5936 60.589 31.1631L74.3363 42.7293C74.7714 43.0956 75.1223 43.5336 75.3828 44.0158L78.4282 42.9469C81.1361 41.9967 81.837 38.4946 79.6582 36.6436C79.643 36.6303 79.6268 36.617 79.6116 36.6046Z",
    fill: "#FFC840"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.873 31.1186C103.023 32.7166 105.551 33.8137 108.288 34.273C104.54 38.0599 102.814 43.3113 103.594 48.552C101.238 47.4026 98.642 46.801 95.9994 46.801C93.3568 46.801 90.7608 47.4026 88.4047 48.552C88.8192 45.7657 88.5255 42.9777 87.5972 40.4073C85.3996 41.1771 83.9512 43.2688 84.0478 45.572C84.0962 46.7213 83.9834 47.8893 83.6996 49.0475L81.5342 57.8974L89.3804 53.1273C91.3722 51.9169 93.6603 51.2763 95.9985 51.2763C98.3367 51.2763 100.625 51.916 102.617 53.1273L110.463 57.8974L108.297 49.0466C107.177 44.4686 108.759 39.657 112.387 36.6035L119.402 30.7019L110.218 30.0029C109.09 29.917 107.999 29.687 106.967 29.3278C104.752 28.5571 102.289 29.2694 100.87 31.1177L100.873 31.1186Z",
    fill: "#FFDE6F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M74.301 84H117.699C118.969 84 120 85.021 120 86.2775V104H72V86.2775C72 85.0201 73.0316 84 74.301 84Z",
    fill: "#8C88A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M67.9837 104H124.016C125.111 104 126 104.877 126 105.957V110.234C126 111.209 125.198 112 124.21 112H67.7895C66.8021 112 66 111.209 66 110.234V105.957C66 104.877 66.8886 104 67.9837 104Z",
    fill: "#8C88A8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.76 90H84.2395C83.555 90 83 90.5805 83 91.2967V96.7033C83 97.4195 83.555 98 84.2395 98H107.76C108.445 98 109 97.4195 109 96.7033V91.2967C109 90.5805 108.445 90 107.76 90Z",
    fill: "#FFC840"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 60.4444C0 60.199 0.198985 60 0.444444 60H48C50.2091 60 52 61.7909 52 64H3.55556C1.59188 64 0 62.4081 0 60.4444Z",
    fill: "#FFA800"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6 64.4444C6 64.199 6.19898 64 6.44444 64H52V68H9.55556C7.59188 68 6 66.4081 6 64.4444Z",
    fill: "#993328"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12 68.4444C12 68.199 12.199 68 12.4444 68H52V72H15.5556C13.5919 72 12 70.4081 12 68.4444Z",
    fill: "#FFA800"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80.4444C30 80.199 30.199 80 30.4444 80H52V84H33.5556C31.5919 84 30 82.4081 30 80.4444Z",
    fill: "#993328"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36 84.4444C36 84.199 36.199 84 36.4444 84H54C56.2091 84 58 85.7909 58 88H39.5556C37.5919 88 36 86.4081 36 84.4444Z",
    fill: "#FFA800"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42 88.4444C42 88.199 42.199 88 42.4444 88H58V91C58 91.5523 57.5523 92 57 92H45.5556C43.5919 92 42 90.4081 42 88.4444Z",
    fill: "#993328"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18 72.4444C18 72.199 18.199 72 18.4444 72H52V76H21.5556C19.5919 76 18 74.4081 18 72.4444Z",
    fill: "#993328"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24 76.4444C24 76.199 24.199 76 24.4444 76H52V80H27.5556C25.5919 80 24 78.4081 24 76.4444Z",
    fill: "#FFA800"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45H49V48H52V45Z",
    fill: "#FFC840"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M140 45H143V48H140V45Z",
    fill: "#FFC840"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41 34H38V37H41V34Z",
    fill: "#F77622"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19 34H16V37H19V34Z",
    fill: "#FFDE6F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M176 34H173V37H176V34Z",
    fill: "#FFDE6F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M151 34H154V37H151V34Z",
    fill: "#F77622"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45H27V48H30V45Z",
    fill: "#993328"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23H27V26H30V23Z",
    fill: "#FFA800"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M165 23H162V26H165V23Z",
    fill: "#FFA800"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M162 45H165V48H162V45Z",
    fill: "#993328"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M192 60.4444C192 60.199 191.801 60 191.556 60H144C141.791 60 140 61.7909 140 64H188.444C190.408 64 192 62.4081 192 60.4444Z",
    fill: "#FFA800"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M186 64.4444C186 64.199 185.801 64 185.556 64H140V68H182.444C184.408 68 186 66.4081 186 64.4444Z",
    fill: "#993328"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M180 68.4444C180 68.199 179.801 68 179.556 68H140V72H176.444C178.408 72 180 70.4081 180 68.4444Z",
    fill: "#FFA800"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M162 80.4444C162 80.199 161.801 80 161.556 80H140V84H158.444C160.408 84 162 82.4081 162 80.4444Z",
    fill: "#993328"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M156 84.4444C156 84.199 155.801 84 155.556 84H138C135.791 84 134 85.7909 134 88H152.444C154.408 88 156 86.4081 156 84.4444Z",
    fill: "#FFA800"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M150 88.4444C150 88.199 149.801 88 149.556 88H134V91C134 91.5523 134.448 92 135 92H146.444C148.408 92 150 90.4081 150 88.4444Z",
    fill: "#993328"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M174 72.4444C174 72.199 173.801 72 173.556 72H140V76H170.444C172.408 76 174 74.4081 174 72.4444Z",
    fill: "#993328"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M168 76.4444C168 76.199 167.801 76 167.556 76H140V80H164.444C166.408 80 168 78.4081 168 76.4444Z",
    fill: "#FFA800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardCup);
export default __webpack_public_path__ + "static/media/leaderboard_cup.3dc6498b3bb9d14445edeecf07d68ab3.svg";
export { ForwardRef as ReactComponent };